import Page from "../Page";
import logo from '../../media/logo.png';
import { errorToast } from "../../toast";
import { showLoading, hideLoading } from "../../loading";
import request from "../../request";
import swal from 'sweetalert';
import actions from "../../redux/actions";
import withRouterParams from "../../withRouterParams";
import { getAccessToken } from "@xavisoft/auth/frontend/utils";
import { decodeJWT } from "../../utils";
import { delay } from "../../utils";
import ResetPassword from "./ResetPassword";


class _Login extends Page {

   state = {
      passwordResetModalOpen: false,
      email: ''
   }

   submit = async () => {
      // extract credentials
      const txtEmail = document.getElementById('txt-email');
      const txtPassword = document.getElementById('txt-password');

      const email = txtEmail.value;
      const password = txtPassword.value;

      // presence check
      if (!email) {
         txtEmail.focus();
         return errorToast('Email is required');
      }

      if (!password) {
         txtPassword.focus();
         return errorToast('Password is required');
      }

      // submit
      try {

         showLoading();

         await request.post('/api/auth/login', { email, password });
         this.setAuthenticatedAndRedirect();

      } catch(err) {
         swal("Error", err.message, "error");
      } finally {
         hideLoading();
      }
   }

   setAuthenticatedAndRedirect() {
      actions.setAuthenticated(true);

      const redirectUrl = this.props.searchParams.redirect || '/dashboard';
      window.App.redirect(redirectUrl);
   }

   checkLoginStatus() {
      const accessToken = getAccessToken();
      if (!accessToken)
         return;

      const decoded = decodeJWT(accessToken);

      if (decoded.exp <= Date.now())
         return;

      const role = decoded?.user?.role;
      this.setAuthenticatedAndRedirect(role, false);
   }

   async componentDidMount() {
      super.componentDidMount();
      await delay(200)
      this.checkLoginStatus();
   }
   
   _render() {
      return <div className="page-height flex items-center justify-center">
         <div className="w-full max-w-xs rounded-lg shadow relative bg-white">

            <div className="absolute shadow aspect-square rounded-full h-24 bg-white z-30 top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
               <img src={logo} alt="" className="w-[70%]" />
            </div>

            <div className="flex flex-col gap-4 p-4 mt-12">
               
               <input
                  type="email"
                  id="txt-email"
                  className="border border-gray-300 rounded-lg p-2"
                  placeholder="Email"
               />

               <input
                  type="password"
                  id="txt-password"
                  className="border border-gray-300 rounded-lg p-2"
                  placeholder="Password"
               />

               <button
                  className="bg-orange-600 text-white w-full rounded-lg py-2"
                  onClick={this.submit}
               >
                  Login
               </button>

               <div className="text-right">
                  <span
                     onClick={() => {
                        this.setState({
                           passwordResetModalOpen: true,
                           email: document.getElementById('txt-email').value
                        });
                     }}
                     className="text-gray-400 cursor-pointer text-sm"
                  >
                     Forgot password?
                  </span>
               </div>
            </div>
         </div>
         {
            this.state.passwordResetModalOpen && <ResetPassword
               email={this.state.email}
               onClose={() => this.setState({ passwordResetModalOpen: false })}
            />
         }
      </div>
   }
}

const Login = withRouterParams(_Login);
export default Login;